const TARGET = 100;
const HUE = 335;
const LIGHTNESS = 55;
const MAX_SATURATION = 91;

export function charCountColor(count: number): string {
  const t = Math.max(0, Math.min(1, count / TARGET));
  const saturation = Math.round(MAX_SATURATION * t);
  return `hsl(${HUE}, ${saturation}%, ${LIGHTNESS}%)`;
}
